import { Component, computed, inject, input } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

@Component({
  selector: 'fin-icon-with-text',
  styleUrls: ['./icon-with-text.component.scss'],
  templateUrl: './icon-with-text.component.html',
  standalone: false,
})
export class IconWithTextComponent {
  private themeService = inject(FinnairThemeService);

  title$ = input<Observable<string>>();
  content$ = input<Observable<string>>();
  icons$ = input<Observable<SvgLibraryIcon[]>>();
  styleClasses$ = input<Observable<string[]>>();

  readonly isNewBrand = computed<boolean>(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);
}
